export default {
  common: {
    more: "View more",
    pleaseInput: "Please enter",
    cancel: "Cancel",
    login: "Log in",
    logout: "Log out",
    logoutFull: "Log out",
    registerNow: "Sign up",
    loginOrRegister: "Log in / Sign up",
    home: "Home",
    mine: "Mine",
    backToTop: "Back to top",
    scanWechat: "Scan to follow our WeChat",
  },
  status: {
    living: "Live now",
    live: "Live",
    video: "Video",
    book: "Book",
    replay: "Replay",
    ended: "Ended",
    collection: "Collection",
  },
  tab: {
    live: "Live",
    living: "Live now",
    latest: "Latest",
    latestActivities: "Latest",
    hot: "Popular",
    hotActivities: "Popular",
  },
  watching: "{n} watching",
  views: "{n} views",
  catalogUpdated: "{n} activities",
  search: {
    hot: "Trending",
    activity: "Activities",
    totalPrefix: "",
    totalSuffix: " results",
  },
  countdown: {
    day: "Days",
    hour: "Hrs",
    minute: "Mins",
    second: "Secs",
    empty: "Please set a countdown time",
  },
  brand: {
    fans: "Followers",
    followAttr: "Following",
    heat: "Popularity",
    visit: "Visits",
    followed: "Following",
    follow: "Follow",
  },
  alert: {
    pageNotFound: "Page not found. Please check the URL.",
    noData: "No page data found. Please make sure it has been saved.",
  },
  alt: {
    brandLogo: "Brand logo",
    banner: "Banner",
    imageNav: "Navigation",
    sudokuNav: "Navigation",
  },
};
